import { AxiosReportLas } from '../config';
const AssetsService = {
  validateLogin: login => {
    return AxiosReportLas({
      method: 'post',
      url: `/v1/Relatorios/ValidarEmailUsuario?login=${login}`,
    });
  },
  sendReport: ({ data, empresa }) => {
    return AxiosReportLas({
      method: 'post',
      url: '/v1/Relatorios/RelatorioAtivos',
      data,
      headers: {
        'Content-Type': 'application/json',

        EmpresaId: empresa,
      },
    });
  },
};

export { AssetsService };
